module.exports = __webpack_public_path__ + "img/Ellipse 120.3bbbc5c4.png";